// controller/auth-context.ts
import { createContext } from "@lit/context";

export interface AuthState {
  isAuthenticated: boolean;
}

export const authContext = createContext<AuthState>("sb:auth");
